import { MyOrganizationQuery, MyOrganizationQueryVariables } from 'generated/graphql'
import gql from 'graphql-tag'
import { getNodes } from 'graphql/utils'
import graphql from 'utils/graphql'

const myOrganization = gql`
fragment myOrganization on OrganizationType {
    id
    name
    language
}
`
export const myOrganizationQuery = gql`
    query myOrganization {
        myOrganizations(first: 499) {
            edges {
                node {
                    ...myOrganization
                }
            }
            totalCount
        }
    }
    ${myOrganization}
`
export const getMyOrganizations = async () => {
    const response = await graphql.createQuery<
        MyOrganizationQuery, MyOrganizationQueryVariables
    >(myOrganizationQuery)({})
    return getNodes(response?.data?.myOrganizations)
}
